<template>
    <a-modal
        v-model:visible="modalVisible"
        wrapClassName="swiper-card-modal"
        title=""
        :width="450"
        :footer="null"
        :centered="true"
    >
        <template #closeIcon>
          <jds-icon name="close-fill" class="text-#999 hover:text-#666 transition-all duration-300 text-48 lg:a-text-32"></jds-icon>
        </template>
        <div>
            <template v-if="!modalDetail.history && modalDetail.imageType !== 1">
                <img
                    class="w-362 h-224 mb-30 object-contain lg:(j-w-180 j-h-111 j-rounded-8 j-mb-24)"
                    :src="modalDetail.image" alt=""
                    @click.prevent="copy"
                >
            </template>
            <template v-else>
                <div class="history" :class="[modalDetail.imageType === 1 ? 'w-[45%] !lg:w-[55%] lg:max-w-[15vw] !pr-0' : '']">
                    <div
                        class="contain"
                        :style="
                            modalDetail.imageType === 1
                                ? `background: url(${modalDetail.image}) left center /contain no-repeat;width:150%;height:100%;`
                                : `background: url('https://cdn.shopifycdn.net/s/files/1/0550/0524/9633/files/ead6f1d359da789814cd78421b6956bb.png?v=1686109159') center center /contain no-repeat`
                            "
                    >
                        <div v-if="modalDetail.imageType !== 1" class="off">{{ modalDetail.off }}</div>
                        <div
                            class="value"
                            :class="[isJP() ? 'text-36 lg:j-text-24' : 'text-40 lg:j-text-30']"
                            :style="modalDetail.imageType === 1 ? 'color:#FE7704;margin-right:25%;white-space:nowrap;' : ''"
                        >
                            {{ modalDetail.rightValue }}
                            <span v-if="modalDetail.imageType === 1" class="text-24 lg:j-text-12">{{modalDetail.off}}</span>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="!modalDetail.discountCode">
                <!-- 兑换后 有 CODE -->
                <template v-if="CODE">
                    <p v-if="modalType === 'Redeem' && props.type !== 'VirtualCard'" class="text-primary">{{ t('member_index.redeem_points.code') }}: {{ CODE }}</p>
                </template>

                <!-- 兑换前 -->
                <template v-else>
                    <!-- 产品 显示 标题+价格+积分 -->
                    <template v-if="props.type === 'Products'">
                        <h2 class="font-semibold text-sub text-28 leading-36 lg:(j-text-18 j-leading-26) relative">{{ modalDetail.goodsTitle }}</h2>
                        <p class="font-normal font-normal text-#808080 text-28 leading-36 my-20 lg:(j-text-18 j-leading-26 j-mt-10 j-mb-15)">
                            {{ modalDetail.currencyTypePrefix === '€' ? `${modalDetail.goodsPrice} ${modalDetail.currencyTypePrefix}` : `${modalDetail.currencyTypePrefix} ${modalDetail.goodsPrice}` }}
                        </p>
                        <p class="inline-block border-3 border-solid border-primary text-primary font-normal font-normal text-32 rounded-6 px-16 py-4 mb-30 lg:(j-border-1 j-text-16 j-leading-16 j-p-6 j-rounded-5 j-mb-15)">
                            {{ modalDetail.pointValue }} {{ t('member_index.common.points' )}}
                        </p>
                    </template>
                    <!-- 优惠券 / 礼品卡 / 虚拟卡 显示积分 -->
                    <template v-else>
                        <p class="text-40 text-sub font-semibold lg:(j-text-20 j-leading-26)">{{modalDetail.pointValue}} {{ t('member_index.common.points' )}}</p>
                    </template>
                </template>

            </template>
            <template v-else>
                <!-- 产品 需要显示 标题 -->
                <template v-if="props.type === 'Products'">
                    <h2 class="font-semibold text-sub text-22 leading-38 lg:(j-text-14 j-leading-24 lg:j-h-48) relative">{{ modalDetail.goodsTitle }}</h2>
                </template>
                <p class="text-primary">
                    <span v-if="modalType === 'Redeem'">{{ t('member_index.redeem_points.code') }}: {{ modalDetail.discountCode }}</span>
                </p>
            </template>
        </div>
        <a-divider />
        <div>
            <h2 class="text-40 leading-64 text-black font-semibold mb-20 lg:j-text-15 lg:j-leading-24 lg:j-mb-10">{{ t('member_index.common.rules') }}</h2>
            <p class="max-h-420 lg:j-max-h-300 overflow-y-auto rules-wrap" v-html="modalRules"></p>
        </div>
        
        <template v-if="modalType === 'Redeem'">
            <a-divider />
            <div v-if="!redeemed">
                <div class="flex items-center gap-x-16 lg:j-gap-x-16">
                    <a-button class="swiper-list-item-button" @click.prevent="modalVisible = false">{{ t('operate.cancel' )}}</a-button>
                    <a-button type="primary" class="swiper-list-item-button" @click.prevent="redeem(modalDetail)">{{ t('member_index.common.redeem' )}}</a-button>
                </div>
            </div>
            <div v-else>
                <h2>{{ t('member_index.redeem_points.successfully_redeemed') }}</h2>
                <p v-if="props.type === 'VirtualCard'">{{ t('member_index.redeem_points.information_tips') }}</p>
                <br/>
                <div class="flex items-center gap-x-16 lg:j-gap-x-16">
                    <a-button class="swiper-list-item-button" @click.prevent="modalVisible = false">{{ t('operate.cancel' )}}</a-button>
                    <a-button v-if="props.type !== 'VirtualCard'" type="primary" class="swiper-list-item-button" @click.prevent="copy">{{ t('member_index.redeem_points.copy_and_use' ) }}</a-button>
                </div>
            </div>
        </template>
    </a-modal>
</template>
<script setup>
import { exchangeRight } from '@a/index'
import { message, Modal } from 'ant-design-vue'
import { copyText, cookie, COLLECTION_LINK, uLogin, } from '@u/common'
import { shopifyLogin } from "@a/userCommon";
import { createVNode, } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const language = computed(() => store.getters.language);

const { t } = useI18n()

const router = useRouter()

const props = defineProps({
    type: String,
    isLogin: Boolean,
})

// code 码
const CODE = ref('')

const cr = cookie.get("_jk_cr") || localStorage.getItem('JACKERY_ID_CR') || 'US'
const isJP = () => ['JP'].includes(cr)

const modalVisible = ref(false)
const modalType = ref('')
const modalDetail = ref('')
// 规则
const modalRules = ref('')
const countDown__finished = ref(false)

// 打开弹窗
const openModal = ({ cardType, cardDetail, cardRules, isFinish }) => {
    CODE.value = ''
    redeemed.value = ''
    modalVisible.value = true

    modalType.value = cardType
    modalDetail.value = cardDetail
    modalRules.value = cardRules
    countDown__finished.value = isFinish
}

// 剩余积分
const remainPoints = ref(0)

const redeemed = ref(false)
const redeemLoading = ref(false)
const jumpGoodsDetailUrl = ref('')
// 兑换
const redeem = (item) => {
    CODE.value = ''
    redeemed.value = false
    // 未登录，则跳转登录页
    if(!props.isLogin) {
        return router.push({ path: '/login', query: {redirect: '/index'} })
    }

    if(item.showCountDown === 1 && countDown__finished.value && item.showAfterEnd !== 0) {
        message.warning(t('member_index.redeem_points.count_down_info'));
        return
    }

    const modal = Modal.confirm({
        title: createVNode('div', null, [
            createVNode('span', null, t('member_index.redeem_points.redeem_confirm_title', [item.pointValue])),
            createVNode('b', { style: { color: '#FD5000' }}, t('member_index.redeem_points.redeem_confirm_subtitle')),
        ]),
        content: createVNode(
            'div', {
                style: 'font-size:16px;font-weight:500;'
            },
            t('member_index.redeem_points.redeem_confirm_content')
        ),
        centered: true,
        width: 430,
        okText: t('operate.confirm'),
        cancelText: t('operate.cancel'),
        onOk: async () => {
            try {
                redeemLoading.value = true
                const { balancePoint, discountCode, ruleInfo, goodsDetailUrl, } = await exchangeRight({ ruleId: item.ruleId, version: item.version, })
                redeemed.value = true

                CODE.value = discountCode
                remainPoints.value = balancePoint

                if (goodsDetailUrl) {
                    jumpGoodsDetailUrl.value = goodsDetailUrl
                }

                modalRules.value = ruleInfo
            } finally {
                redeemLoading.value = false

                modal.destroy()
            }
        }
    });
}


const SHOP_ID = cookie.get("_jk_shop_id") || localStorage.getItem('JACKERY_ID_SHOP_ID')
// 复制
const copy = async () => {
    if (!CODE.value) return

    const data = await copyText(CODE.value)
    if (data) {
        message.success(t('member_index.common.copy_successfully'))
        //日本临时活动
        if(data == "SwitchBot15"){
            let jpLink="https://www.switchbot.jp?utm_source=referral&utm_medium=jackery&utm_campaign=point"
            window.open(jpLink)
        }else if(data == "JAKW20"){
            let usLink="https://www.simpurelife.com"
            window.open(usLink)
        }else{
            const CR = cookie.get("_jk_cr") || localStorage.getItem('JACKERY_ID_CR') || 'US'
            // 产品 跳产品下单页，优惠券/礼品卡 跳转官网 Collection 页面
            const url = props.type === 'Products' ? jumpGoodsDetailUrl.value : `https://${language.value.current.domain}${COLLECTION_LINK[CR]}`
            setTimeout(() => {
                uLogin(shopifyLogin, SHOP_ID, url, true)
            }, 1500)
        }  
    }
}

defineExpose({
    openModal,
})
</script>
<style scoped>
.swiper-list-item-button {
  @apply
    lg:(j-min-w-120 j-min-h-40) !lg:j-text-18 !rounded-full
}
.history {
  @apply
    w-362 h-224 px-50 lg:j-w-180 lg:j-h-111 lg:j-px-30 flex-center
}
.contain {
  @apply
    w-full h-full flex-center color-white font-semibold relative
}
.off {
  @apply absolute right-10 top-40 lg:j-right-6 lg:j-top-24 text-24 lg:j-text-12 font-semibold
}
.value {
  @apply font-semibold
}
::v-deep(.rules-wrap ul li) {
@apply list-disc-inside
}
::v-deep(.rules-wrap ol li) {
  @apply list-decimal-inside
}
</style>
